import { useQuery, useQueryClient, QueryKey } from "@tanstack/react-query";
import Decimal from "decimal.js";
import { z } from "zod";
import moment, { Moment } from "moment-timezone";
import {
  fetchApiDelete,
  fetchApiGet,
  fetchApiPost,
  fetchApiPut,
} from "../utils";

const UpdateFlagBodyValidation = z.object({
    flagId: z.string().uuid(),
    newStatus: z.boolean()
})

export interface Flag {
    id: string;
    enabled: boolean;
    flag_status: boolean;
    flag_type: string;
    label: string;
}

export function useListGeneralContractFlags() {
  const queryParams = new URLSearchParams();

  return useQuery({
    queryKey: ["flags", "generalContracts"],
    queryFn: () => fetchApiGet<Flag[]>("flags/contract", queryParams),
    retry: 1,
    refetchInterval: 8 * 1000,
  });
}

export function useUpdateGeneralContractFlag() {
  const queryClient = useQueryClient();

  return async (body: typeof UpdateFlagBodyValidation._type) => {
    const queryParams = new URLSearchParams();

    const result = await fetchApiPut<any>(
      `flags/contract/${body.flagId}`,
      body,
      queryParams,
    );

    if (result.success) {
        queryClient.invalidateQueries({ queryKey: ["flags", "generalContracts"] });
    }

    return result;
  };
}
